import { useEffect, useState } from 'react';
import { GetCaptchImageService } from '../../utils/services/registration/donor-registration.service';
import { CaptchaState } from '../../utils/dto/response/recaptcha';
import { Box, CircularProgress, Divider, Grid, IconButton, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import PageLang from '../../config/page.languge';
interface ReCaptchaComponentProps {
    onCaptchaValue: (captchaState: CaptchaState) => void;
    resetCaptch: boolean;
}

const ReCaptchaComponent: React.FC<ReCaptchaComponentProps> = ({ onCaptchaValue, resetCaptch }) => {

    const [captchaState, setCaptchaState] = useState<CaptchaState>({ imageSrc: null, captchaValue: '', error: '', });
    const [loading, setLoading] = useState<boolean>(false);
    const [Error, setError] = useState('');

    const getCaptchaImage = async () => {
        setLoading(true);
        const { code, data } = await GetCaptchImageService({});
        if (code === 200) {
            setLoading(false);
            setCaptchaState((prev) => ({ ...prev, imageSrc: { captcha_image: data.captcha_image, uuid: data.ref }, captchaValue: '', error: '', }));
        } else {
            setLoading(false);
            setError(lang === 'English' ? "Failed to Fetch Captcha!" : "कैप्चा प्राप्त करने में विफल!")
        }
    };
    const lang = useSelector((state: RootState) => state.lang.language)
    useEffect(() => {
        onCaptchaValue(captchaState);
    }, [captchaState]);

    useEffect(() => {
        if (resetCaptch) {
            getCaptchaImage();
        }
    }, [resetCaptch]);

    return (
        <>
            {loading
                ?
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', }} > <CircularProgress /> </Box>
                :
                <Grid item xs={12} textAlign="center" sx={{ pb: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 2}}>
                        <Typography variant="h6" color={Error ? 'primary' : "info"} fontWeight={600}>
                            {Error ? Error : PageLang.loginOptions[13][lang]}
                        </Typography>
                    </Box>

                    {captchaState.imageSrc && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, my: 1 }}>
                            <Box
                                component="img"
                                src={captchaState.imageSrc.captcha_image}
                                alt="captcha"
                                sx={{ height: 40, maxWidth: '70%', borderRadius: 1, border: '1px solid #ccc', px: 1, bgcolor: '#fff' }}
                            />
                            <Tooltip title='New Captcha'>
                                <IconButton onClick={getCaptchaImage} aria-label="Refresh Captcha" sx={{ border: '1px solid #ccc' }}>
                                    <Refresh fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <TextField
                                label={PageLang.loginOptions[14][lang]}
                                size="small"
                                required
                                variant="outlined"
                                fullWidth
                                value={captchaState.captchaValue}
                                onChange={(e) => setCaptchaState((prev) => ({ ...prev, captchaValue: e.target.value, error: '' }))}
                                sx={{ flex: 1 }}
                                inputProps={{
                                    maxLength: 4,
                                    onPaste: (e: React.ClipboardEvent) => e.preventDefault(),
                                    onCopy: (e: React.ClipboardEvent) => e.preventDefault(),
                                    style: {
                                        userSelect: 'none',
                                        color: 'white',
                                        mixBlendMode: 'difference',
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="end">
                                            <ArtTrackIcon fontSize="small" sx={{ mr: 1 }} color="primary" />
                                            <Divider orientation="vertical" sx={{ height: 15 }} textAlign="center" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}
                </Grid>
            }
        </>
    );
};

export default ReCaptchaComponent;